import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=070654b5&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=070654b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070654b5",
  null
  
)

export default component.exports